export const defaultTolls = [
  {
    id: 1,
    tollName: "Chengalpattu",
    vechileType1: "car/jeep/van",
    single1: 60,
    double1: 30,
    vechileType2: "lcv",
    single2: 95,
    double2: 50,
    vechileType3: "truck/bus",
    single3: 205,
    double3: 100,
    vechileType4: "heavy-vechile",
    single4: 320,
    double4: 160,
  },
  {
    id: 2,
    tollName: "Kappalur",
    vechileType1: "car/jeep/van",
    single1: 75,
    double1: 50,
    vechileType2: "lcv",
    single2: 125,
    double2: 80,
    vechileType3: "truck/bus",
    single3: 260,
    double3: 120,
    vechileType4: "heavy-vechile",
    single4: 400,
    double4: 200,
  },
  {
    id: 3,
    tollName: "Krishnagiri",
    vechileType1: "car/jeep/van",
    single1: 70,
    double1: 40,
    vechileType2: "lcv",
    single2: 110,
    double2: 65,
    vechileType3: "truck/bus",
    single3: 235,
    double3: 130,
    vechileType4: "heavy-vechile",
    single4: 365,
    double4: 200,
  },
];

export const defaultEntry = [
  {
    id: 1,
    tollname: "Chengalpattu",
    vechileType: "car/jeep/van",
    vechileNo: "TN24AQ4644",
    tariff: 60,
    date: "18-9-2022,15:27:41",
  },
  {
    id: 2,
    tollname: "Kappalur",
    vechileType: "car/jeep/van",
    vechileNo: "TN19QQ1234",
    tariff: 75,
    date: "18-9-2022,15:28:2",
  },
  {
    id: 3,
    tollname: "Kappalur",
    vechileType: "heavy-vechile",
    vechileNo: "TN24AA1234",
    tariff: 400,
    date: "18-9-2022,15:28:20",
  },
];
